<template>
  <span>{{ playerCount }}</span>
</template>

<script>
import * as sAPI from '../api/strapi.js'
export default {
  props: {
    gameID: {
      required: true
    }
  },
  data () {
    return {
      playerCount: 0
    }
  },
  mounted () {
    sAPI.getPlayerCount({ gameID: this.gameID })
      .then((v) => {
        this.playerCount = v
      })
  }
}
</script>

<style>

</style>
